import type { PivotLayoutCalculatedMeasure, PivotLayoutField, PivotLayoutMeasure } from '@ztechapps/common.contract'

/** Whether a layout zone item is a calculated value rather than an aggregation. */
export const isPivotCalculatedMeasure = (
  measure: PivotLayoutField | PivotLayoutMeasure
): measure is PivotLayoutCalculatedMeasure => 'formula' in measure
